const e = {
  text: {
    borderRadius: "xl"
  }
}, s = {
  skeletons: e
};
export {
  s as skeletonsTheme
};
